import React, { Component, ReactElement } from 'react'
import styles from './Agreement.module.scss'
import { Checkbox } from 'antd'
import { Translate, withLocalize } from 'react-localize-redux'
import { updateAgreement } from 'core/actions/Users.actions'
import { ACCOUNTS_LOCALE_COOKIE_NAME } from 'core/utils/constants'
import { AgreementProps, IAgreementPropsState } from './Agreement.types'
import { connect } from 'react-redux'
import { IAppState } from 'core/store/store'
import Cookies from 'js-cookie'
import { Button, DropDown } from '@digicert/dcone-common-ui'
import { ReactComponent as GlobeAmericas } from '../../assets/images/globe-americas.svg'
import { fetchLocales } from '../../core/actions/Settings.actions'

class Agreement extends Component<AgreementProps, {}> {
  state = {
    checked: false,
    agreementUrl: 'http://www.digicert.com/master-services-agreement',
    policyUrl: 'https://www.digicert.com/digicert-privacy-policy/',
    locales: undefined,
    selectedLanguage: 'English',
    isLoading: true
  }

  public componentDidMount () : void {
    const langCode = Cookies.get(ACCOUNTS_LOCALE_COOKIE_NAME)
    if (langCode) {
      this.props.setActiveLanguage(langCode.split('_')[0])
      if (langCode === 'ja_JP') {
        this.setState({agreementUrl: 'https://www.digicert.com/master-services-agreement-JP'})
      }
    }

    this.props.fetchLocales().then((response) => {
      // update active language on change
      const onLocaleChange = (language: string, countryCode: string) => {
        this.setState({selectedLanguage: language})
        // prevent flash of untranslated content when changing languages
        this.setState({isLoading: true})
        Cookies.set(ACCOUNTS_LOCALE_COOKIE_NAME, countryCode, { secure: true })
        this.props.setActiveLanguage(countryCode.split('_')[0])
        window.location.reload()
      }

      // format key values for drop down
      this.setState({
        locales: response.map((item) => {
          return {
            key: item.id,
            label: item.name,
            onClick: () => onLocaleChange(item.name, item.id)
          }
        })
      })

      // if cookie lang set use as default
      if(langCode) {
        this.setState({selectedLanguage: response.find(res => res.id === langCode).name})
      }

      this.setState({isLoading: false})
    })
  }

  public uptAgreement = async (): Promise<void> => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const stateVal = urlSearchParams.get('state')
    const key = urlSearchParams.get('key')

    await this.props.updateAgreement(this.props.match.params.userId, Cookies.get(ACCOUNTS_LOCALE_COOKIE_NAME), stateVal, key)
  }

  public render (): ReactElement {
    const currentYear = new Date().getFullYear()
    const {agreementUrl, policyUrl, locales, selectedLanguage} = this.state

    if(!this.state.isLoading) {
      return (
        <>
          <div className={styles.backgroundColor}>
            <div className={styles.dcOneLogo}/>
            <div className={styles.rectangle}>
              <p className={styles.heading}><Translate id='common.agreement.title'/></p>
              <div className={styles.groupName}>
                <Checkbox
                  className={styles.checkGroup}
                  onClick={() => {
                    this.setState({checked: !this.state.checked})
                  }}
                />
                <p className={styles.agree}><Translate id='common.agreement.detail'/>
                  <a className={styles.dsa} href={agreementUrl}><Translate id='common.agreement.dsa'/></a>
                  <span> <Translate id='common.agreement.and'/> </span>
                  <a className={styles.pp} href={policyUrl}><Translate id='common.agreement.policy'/></a>
                </p>
              </div>

              <div className={styles.actions}>
                <Button disabled={!this.state.checked} onClick={this.uptAgreement}>
                  <Translate id='common.agreement.acceptBtn'/>
                </Button>
              </div>
            </div>

            <div className={styles.languageOptions}>
              <GlobeAmericas className={styles.icon}/>
              <DropDown label={selectedLanguage} items={locales} color='blue' placement='topRight'/>
            </div>

            <div className={styles.termsOfUse}>
              <div className={styles.links}>
                <a className={styles.termsOfUseLinks} href="https://www.digicert.com/security-terms/"><Translate
                  id='common.agreement.terms'/></a>
                <a className={styles.termsOfUseLinks}
                   href="https://www.digicert.com/digicert-privacy-policy/"><Translate
                  id='common.agreement.policy'/></a>
                <a className={styles.termsOfUseLinks} href="https://www.digicert.com/legal-repository/"><Translate
                  id='common.agreement.legal'/></a>
                <a className={styles.termsOfUseLinks} href="https://www.digicert.com/webtrust-audits/"><Translate
                  id='common.agreement.audit'/></a>
                <a className={styles.termsOfUseLinks} href="https://www.digicert.com/support/"><Translate
                  id='common.agreement.support'/></a>
                <a className={styles.termsOfUseLinks} href="https://www.digicert.com/contact-us/"><Translate
                  id='common.agreement.contact'/></a>
              </div>
              <div className={styles.copyrightInfo}>
                &copy; {currentYear} <Translate id='common.agreement.copyright'/>
              </div>
            </div>
          </div>
        </>
      )
    }
    else return <></>
  }
}

export default connect(
  (state: IAppState, props: IAgreementPropsState) => {
    return {
      checked: false,
      isLoading: state.users.isLoading
    }
  },
  {
    updateAgreement,
    fetchLocales
  })(withLocalize(Agreement))
